/** @jsxImportSource @emotion/react */
import { css, jsx } from '@emotion/react';
import { Pagination, Table } from 'antd';
import React from 'react';
import config from '../../config';

const CustomTable = ({ rowHeight = 3, pageSize = 10, data, columns, loading, totalUsers, page,handlePageChange,...rest }) => {

  const darkThemeStyles = css`
    .ant-table-thead > tr > th {
      background-color: #32394E !important;
      border-color: #32394E;
      color: #A6B0CF;
      font-weight: bold;
      text-align: center;
      padding: 10px;
      ::before{
        background-color: gray !important;
      }
    }
    .ant-table-tbody > tr > td {
      background-color: #2A3042 !important;
      border-color: #32394E;
      color: #A6B0CF;
      padding: ${rowHeight}px;
      text-align: center;
    }
    .ant-table-tbody > tr:hover > td {
      border-color: #222736 !important;
    }
  `;
  const darkPaginationStyles = css`
    .ant-pagination-item {
    background-color: #2A3042;
    border: 1px solid #444;
    color: #fff;
    }
    .ant-pagination-item:hover,
    .ant-pagination-item-active {
      background-color: #32394E;
      border-color: ${config.color.secondaryColor};
    }
    .ant-pagination-item-active a {
      color: #fff;
    }
    .ant-pagination-prev,
    .ant-pagination-next {
      background-color: #28293e;
      border: 1px solid #444;
      color: white !important;
    }
    .ant-pagination-prev:hover,
    .ant-pagination-next:hover {
      background-color: #33334d;
      border-color: #5e5e7a;
    }
  `;

  return (
    <div>
        <Table
            loading={loading}
            scroll={{ x: 'min-content' }}
            css={darkThemeStyles}
            pagination={false}
            columns={columns}
            dataSource={data}
        />
        <Pagination
            style={{display: "flex", justifyContent: "end", paddingTop: "1rem"}}
            className='pagination'
            css={darkPaginationStyles}
            current={page}
            total={totalUsers}
            pageSize={pageSize}
            showSizeChanger={false}
            onChange={handlePageChange}
        />
    </div>
  );
};

export default CustomTable;
